import { Box, Flex, SectionTitle } from '@shared/components';
import type { PropsWithChildren } from '@shared/utils';

export interface BaseItemSetSubQuestionSectionProps extends PropsWithChildren {
  slotProps?: {
    title?: {
      endAdornment?: React.ReactNode;
    };
  };
}

export default function BaseItemSetSubQuestionSection(
  props: Readonly<BaseItemSetSubQuestionSectionProps>,
) {
  const { children, slotProps } = props;

  return (
    <Flex sx={{ flexDirection: 'column', gap: (theme) => theme.spacing(4) }}>
      <SectionTitle title='Sub-Question' endAdornment={slotProps?.title?.endAdornment} />
      <Box>{children}</Box>
    </Flex>
  );
}
